import { useTranslation } from "react-i18next";
import { SettingsSection } from "./settingSection.component";
import { NumberSettingInput } from "./numberSettingInput.component";

export const DeductionSetting: React.FC<{
  value: number;
  onChange: (v: number) => void;
}> = ({ value, onChange }) => {
  const { t } = useTranslation();
  return (
    <SettingsSection
      title={t("System.Deduction")}
      info={t("System.DeductionInfo")}
    >
      <NumberSettingInput
        label={t("System.Deduction")}
        value={value}
        onChange={onChange}
      />
    </SettingsSection>
  );
};